import { Component, Input, Output, EventEmitter } from '@angular/core';
import { LoginService } from '../../auth/login/login.service';

@Component({
  selector: 'cm-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss'],
})
export class TopbarComponent {

  @Input()
  public title: string;
  @Input()
  public titleRouterLink: string;
  @Input()
  public titleNext: string;

  @Output()
  public titleClick = new EventEmitter<any>();

  constructor(private loginService: LoginService) {
  }

  public logout() {
    this.loginService.logout(true);
  }

  onClickTitle() {
    this.titleClick.emit();
  }

}
